import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { AuthService } from './auth.service';
import { IValoresFiltro } from 'src/interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})
export class DataConnectService {
  env = environment;
  ELtoken: any;
  baseUrl = this.env.endpointURL;
  lista: any;
  oirsasignacion: any;
  reporte:any;
  listaRepar: any;
  respuesta: any;
  volver:any

  valoresFiltro: any={
    fechaI:"",
    fechaT:"",
    tipo :"-1",
    nrosolicitud:"-1",
    Estado : "99",
    apellido : null,
    nombre : null,
    palabra : null,
    genero :'-1',
    documentopersona : '-1',
    repar : '0',
  }

  constructor(private http: HttpClient, private auth:AuthService) { }

//   bandejaentrada( tpusuario, nrrut, fechaI, fechaT, Estado, repar) {

//     console.log(tpusuario,'tpusuario')
//     console.log(nrrut,'nrrut')
//     console.log(fechaI,'fechaI')
//     console.log(fechaT,'fechaT')
//     console.log(Estado,'Estado')
//     console.log(repar,'repar')
// console.log(this.baseUrl + `/bandejaentrada/${tpusuario}/${nrrut}/${fechaI}/${fechaT}/${Estado}/${repar}`,"pablo jimenez d")
//     return this.http.get(this.baseUrl + `/bandejaentrada/${tpusuario}/${nrrut}/${fechaI}/${fechaT}/${Estado}/${repar}`).pipe(
//       map(resp => {
//         this.renewtoken(resp['renewtoken'])
//         this.lista = resp['result'];
//         return this.lista;
//       }));
//   }


setValoresFiltro(fechaI, fechaT,Estado, repar, genero,  tipo,nrosolicitud,  documentopersona,  nombre,  apellido,  palabra){
  this.valoresFiltro.fechaI = fechaI
  this.valoresFiltro. fechaT  =  fechaT
  this.valoresFiltro.Estado = Estado
  this.valoresFiltro.repar  =  repar
  this.valoresFiltro.genero =  genero
  this.valoresFiltro.tipo =  tipo
  this.valoresFiltro.nrosolicitud= nrosolicitud
  this.valoresFiltro.documentopersona =  documentopersona
  this.valoresFiltro.nombre =  nombre
  this.valoresFiltro.apellido =  apellido
  this.valoresFiltro.palabra  =  palabra
  console.log('valores filtro', this.valoresFiltro)

}

getValoresFiltro(){
  return this.valoresFiltro
}

  bandejaentradaDos(
    tpusuario,
    nrrut,
    fechaI,
    fechaT,
    Estado,
    repar,
    genero = '-1',
    tipo = '-1',
    nrosolicitud="-1",
    documentopersona = '-1',
    nombre = '-1',
    apellido = '-1',
    palabra = '-1') {
    if (nombre==null) {nombre='-1'}
    if (apellido==null) {apellido='-1'}
    if (palabra==null) {palabra='-1'}

    return this.http.get(this.baseUrl + `/bandejaentrada1/${tpusuario}/${nrrut}/${fechaI}/${fechaT}/${Estado}/${repar}/${genero}/${tipo}/${nrosolicitud}/${documentopersona}/${nombre}/${apellido}/${palabra}`).pipe(
      map(resp => {
        this.renewtoken(resp['renewtoken'])
        this.lista = resp['result'];
        return this.lista;
      }));
  }


  IoirsRespuestaDirecta(IDSolicitud: Number, NRrut: Number, oirsrespuesta: object, datosusuario:Object) {
    return this.http.post(this.baseUrl + `/IoirsRespuestaDirecta`, { IDSolicitud: IDSolicitud, NRrut: NRrut, oirsrespuesta: oirsrespuesta,datosusuario:datosusuario }).pipe(
      map(resp => {
        console.log(resp['result'], 'IoirsRespuestaDirecta')
        this.renewtoken(resp['renewtoken'])
        this.lista =  resp['result'];;
        return this.lista;
      }));
  }
  IoirsRespuestaAsignado(IDSolicitud: Number, NRrut: Number, oirsrespuesta: object, datosususrio:object) {
    return this.http.post(this.baseUrl + `/IoirsRespuestaAsignado`, { IDSolicitud: IDSolicitud, NRrut: NRrut, oirsrespuesta: oirsrespuesta, datosusuario:datosususrio }).pipe(
      map(resp => {
        //console.log('asd')
        this.renewtoken(resp['renewtoken'])
        this.lista =  resp['result'];;
        return this.lista;
      }));
  }
  finalizar(IDSolicitud){
    return this.http.post(this.baseUrl + `/finalizar`, { IDSolicitud: IDSolicitud, NRRutUsuario:this.auth.datosusuario.data.rut }).pipe(
      map(resp => {
        //console.log('asd')
        this.renewtoken(resp['renewtoken'])
        this.lista =  resp['result'];;
        return this.lista;
      }));
  }
  BReparticionAsignar() {

    return this.http.get(this.baseUrl + `/BReparticionAsignar`).pipe(
      map(resp => {
        //console.log('asd')
        this.renewtoken(resp['renewtoken'])
        this.listaRepar =  resp['result'];;
        return this.listaRepar;
      }));
  }
  IoirsAsignacion(IDSolicitud: Number, NRrut: Number, oirsasgina: FormControl, datosusuarios:object) {
    return this.http.post(this.baseUrl + `/IoirsAsignacion`, { IDSolicitud: IDSolicitud, NRrut: NRrut, oirsasgina: oirsasgina, datosusuarios:datosusuarios}).pipe(
      map(resp => {
        //console.log('asd')
        this.renewtoken(resp['renewtoken'])
        this.oirsasignacion =  resp['result'];;
        return this.oirsasignacion;
      }));
  }
  Imagenes(IDSolicitud: Number) {
        return this.http.get(this.baseUrl + `/imagenes/${IDSolicitud}`).pipe(
      map(resp => {
        //console.log('asd')
        this.renewtoken(resp['renewtoken'])
        this.oirsasignacion =  resp['result'];;
        return this.oirsasignacion;
      }));
  }
  ver(IDSolicitud: Number, reparticion: Number) {
    //console.log(reparticion)
    return this.http.get(this.baseUrl + `/ver/${IDSolicitud}/${reparticion}`).pipe(
      map(resp => {
        this.renewtoken(resp['renewtoken'])
        //console.log(resp['result'])
        //this.reporte = resp;
        return resp['result'];
      }));
  }
  renewtoken(newtoken){
    this.auth.refreshToken(newtoken)

  }

  getGenero() {
    return this.http.get(`${this.baseUrl}/getGenero`)
  }

  getTipoSolicitud() {
    return this.http.get(`${this.baseUrl}/getTipoSolicitud`)
  }
  setTokenOficial(token) {
    this.ELtoken = token
    console.log("el token", this.ELtoken)
  }

  getTokenOficial() {
    return this.ELtoken
  }

  verificaTokenOficial() {
    //console.log("verificando token")
    let token = this.ELtoken

    return this.http.get(this.baseUrl + `/verifica/` + token)
  }

}


